import { NamedEntityDto } from '../clinical-details';

export class DispositionDto extends NamedEntityDto {}
